module.exports = __webpack_public_path__ + "static/img/wechat@2x.eb9032e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat@2x.png
// module id = idNc
// module chunks = 3